import { mobx } from '@/lib/mobx';

export const getExpressCalculations = <T>(preset: T[] = [], isShowComboBooster = false) => {
  const { betslip } = mobx;
  const { getOutcomeByLID } = mobx.store;

  const comboBoostLevels = betslip.comboBoostLevels.slice(0, -2);
  const boostedOddsMaxLevel = comboBoostLevels.slice(-1)[0] || { num: 0 };
  const boostedOddsMaxNum = boostedOddsMaxLevel.num;

  const boostedOdds = betslip.getBoostedOdds(preset, betslip.minBoostOdd);
  const boostLevels = betslip.getBoostLevels(
    boostedOdds,
    boostedOddsMaxNum,
    comboBoostLevels,
    boostedOddsMaxLevel,
  );
  const expressOdd = betslip.getExpressOdd({
    bets: preset,
    boostLevels,
    getOutcomeByLID,
    isShowComboBooster,
  });

  const hasIgnoredDiscipline = preset.some(({ disciplineId = '' }) =>
    betslip.forbiddenComboBoostDisciplines.includes(disciplineId),
  );

  const isComboBoosted = betslip.getIsComboBoosted({
    boostedOdds,
    comboBoostLevels,
    isShowComboBooster,
  });

  return {
    boostLevels,
    boostedOdds,
    boostedOddsMaxLevel,
    boostedOddsMaxNum,
    comboBoostLevels,
    expressOdd,
    isComboBoosted: isComboBoosted && !hasIgnoredDiscipline,
    minBoostOdd: betslip.minBoostOdd,
  };
};
